import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';

class Usecases extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { trans } = this.props;
        return (
            <div>
                <Header trans={trans}
                    active="use cases"
                    className="image-hero busines-2"
                    style={{backgroundImage: 'url(/static/images/home_bg_bigger.jpg)'}}
                    title="Business Usecases for Chatbot"
                    body="Checkout these examples below demonstrating how Chatbot can fit to almost any business. Your marketers, customer supporters and Sale people will love their new virtual colleague."
                />

                <div className="w-dyn-list">
                    <div className="w-dyn-items">
                        <div className="w-dyn-item">
                            <div className="section feature-section">
                                <div className="container usecase-row w-container">
                                    <div className="feature-text-block right">
                                        <div className="feature-intro-title">{trans('business usecase')}</div>
                                        <h2 className="main-feature-title">
                                            {trans('Sport and Entertainment')}
                                        </h2>
                                        <p>
                                           {trans(' Bots will give fans the sense of being part of a conversation with a fellow supporter of their favorite team')}
                                        </p>
                                        <a href="#" className="button w-button">{trans('Learn more')}</a>
                                    </div>
                                    <img src="/static/images/5a1d256c7ceb0c000128e6e0_usecase-sport.jpg" alt="Sport &amp; Entertainment" className="browser-mockup-left small" />
                                </div>
                            </div>
                        </div>
                        <div className="w-dyn-item">
                            <div className="section feature-section">
                                <div className="container usecase-row w-container">
                                    <div className="feature-text-block right">
                                        <div className="feature-intro-title">{trans('business usecase')}</div>
                                        <h2 className="main-feature-title">
                                            {trans('Jobs and HR')}
                                        </h2>
                                        <p>
                                            {trans('The recruitment process is never as simple as it sounds, it can take far too long. Chatbots can solve that problem')}
                                        </p>
                                        <a href="#" className="button w-button">{trans('Learn more')}</a>
                                    </div>
                                    <img src="/static/images/5a1d257b07d9180001e38840_usecase-hr.jpeg" alt="Jobs &amp; HR" className="browser-mockup-left small" />
                                </div>
                            </div>
                        </div>
                        <div className="w-dyn-item">
                            <div className="section feature-section">
                                <div className="container usecase-row w-container">
                                    <div className="feature-text-block right">
                                        <div className="feature-intro-title">{trans('business usecase')}</div>
                                        <h2 className="main-feature-title">{trans('Banking')}</h2>
                                        <p>
                                            {trans('Phone banking SMS banking has been around for a while. Why not banking with chatbot')}
                                        </p>
                                        <a href="#" className="button w-button">{trans('Learn more')}</a>
                                    </div>
                                    <img src="/static/images/5a1d25925c97d3000174ce63_usecase-banking.jpeg" alt="Banking" className="browser-mockup-left small" />
                                </div>
                            </div>
                        </div>
                        <div className="w-dyn-item">
                            <div className="section feature-section">
                                <div className="container usecase-row w-container">
                                    <div className="feature-text-block right">
                                        <div className="feature-intro-title">{trans('business usecase')}</div>
                                        <h2 className="main-feature-title">{trans('News and Media')}</h2>
                                        <p>
                                            {trans('Social messaging apps are more popular than social networks now can media companies adapt to this new landscape')}
                                        </p>
                                        <a href="#" className="button w-button">{trans('Learn more')}</a>
                                    </div>
                                    <img src="/static/images/5a1d259e7ceb0c000128e7c7_usecase-news.png" alt="News and Media" className="browser-mockup-left small" />
                                </div>
                            </div>
                        </div>
                        <div className="w-dyn-item">
                            <div className="section feature-section">
                                <div className="container usecase-row w-container">
                                    <div className="feature-text-block right">
                                        <div className="feature-intro-title">{trans('business usecase')}</div>
                                        <h2 className="main-feature-title">{trans('Healthcare')}</h2>
                                        <p>
                                            {trans('Chatbots are capable of detecting symptoms assisting in appointment booking record tracking')}
                                        </p>
                                        <a href="#" className="button w-button">{trans('Learn more')}</a>
                                    </div>
                                    <img src="/static/images/5a1d25a98802490001d454a9_usecase-health.jpg" alt="Healthcare" className="browser-mockup-left small" />
                                </div>
                            </div>
                        </div>
                        <div className="w-dyn-item">
                            <div className="section feature-section">
                                <div className="container usecase-row w-container">
                                    <div className="feature-text-block right">
                                        <div className="feature-intro-title">{trans('business usecase')}</div>
                                        <h2 className="main-feature-title">{trans('Travel and Transportation')}</h2>
                                        <p>
                                            {trans('Chatbot - the perfect vehicle for getaways. Consumers can do planning, riding, booking, servicing with a chatbot')}
                                        </p>
                                        <a href="#" className="button w-button">{trans('Learn more')}</a>
                                    </div>
                                    <img src="/static/images/5a1d25b65c97d3000174ce6f_usecase-travel.jpg" alt="Travel &amp; Transportation" className="browser-mockup-left small" />
                                </div>
                            </div>
                        </div>
                        <div className="w-dyn-item">
                            <div className="section feature-section">
                                <div className="container usecase-row w-container">
                                    <div className="feature-text-block right">
                                        <div className="feature-intro-title">{trans('business usecase')}</div>
                                        <h2 className="main-feature-title">{trans('E-commerce')}</h2>
                                        <p>
                                            {trans('Let is your user has a new shopping experience')}
                                        </p>
                                        <a href="#" className="button w-button">{trans('Learn more')}</a>
                                    </div>
                                    <img src="/static/images/5a1d25c28802490001d454b8_usecase-ec.jpg" alt="E-commerce" className="browser-mockup-left small" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section feature-section section-empty"></div>
                <div className="section cta-section">
                    <div className="container w-container">
                        <h4 className="dark-cta-title">
                            {trans('Join')} 150,000+ {trans('businesses around the world that entrust chatbots to interface with their customers')}
                        </h4>
                        <a href="#" data-ix="open-sign-up-popup" target="_blank" className="button cta-button w-button">{trans('Get Started FREE')}</a>
                    </div>
                </div>

                <Footer trans={trans} />
            </div>
        )
    }

}

export default connect(state => ({

}), {

})(Usecases);






// WEBPACK FOOTER //
// ./src/pages/Usecases.js